import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatmessageruiComponent } from './chatmessagerui.component';
import { CustomFlexLayoutModule } from '../flex-layout/custom-flex-layout.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonFileUploadModule } from '../../global/common-file-upload/common-file-upload.module';


@NgModule({
  declarations: [ChatmessageruiComponent],
  imports: [
    CommonModule,
    CustomFlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    CommonFileUploadModule
  ],
  exports: [ChatmessageruiComponent]
})
export class ChatmessageruiModule { }
